// extracted by mini-css-extract-plugin
export var footer = "_ms-5";
export var fulfillmentInput = "_ms-0";
export var shipDateInput = "_ms-1";
export var shipmentModal = "_ms-2";
export var shipmentModalContent = "_ms-3";
export var tableContainer = "_ms-4";